import React from "react";
import "./bars.scss";
import "../styles/modales.css";

import { NavLink } from "react-router-dom";
import { AiOutlineLogout } from "react-icons/ai";
import { Image } from "react-bootstrap";
import {
  BsHouseFill,
  BsFileEarmarkBreakFill,
  BsGlobe,
  BsFileEarmarkTextFill,
  BsFillFileEarmarkCheckFill,
  BsFillFileEarmarkExcelFill,
  BsClipboard2CheckFill,
} from "react-icons/bs";
import AuthService from "../../src/services/auth.service";
import { jwtDecode } from "jwt-decode";

export default function Sidebar() {
  const token = localStorage.getItem("user");
  const userRole = token ? jwtDecode(token).TipoUsuario : null;
  const Name = token ? jwtDecode(token).sub : null;
  const TISPC = "TISPC";
  const handleLogout = () => {
    AuthService.logout();
    localStorage.clear();
    window.location.reload();
  };

  return (
    <div className="sidebar">
      <div className="w-100">
        <Image
          src="/images/sidebar.png"
          fluid
            className="verticalalign pt-1"
        />
        <p className="text-center text-white fs-9">
          <strong>v3.0</strong>
        </p>
      </div>
      <p className="text-center text-white fs-5">
        <strong>{userRole}</strong><br/>
        {Name}
      </p>
      <ul>
        <li>
          <NavLink
            to="/home"
            className="text-white rounded py-2 w-100 d-inline-block px-1"
          >
            <BsHouseFill className="me-1" />
            Inicio
          </NavLink>
        </li>

        {userRole === TISPC ? (  
         <li>
          <strong className="gobtext">Usuarios:</strong>
    
          <NavLink
            to="/usuarios"
            className="text-white rounded py-2 w-100 d-inline-block px-1"
          >
            <BsFillFileEarmarkExcelFill className="me-1" />
            Lista
          </NavLink>
        </li>
        ): null}

        <li>
          <strong className="gobtext">Actas:</strong>
        </li>
        <li>
          <li>
          <NavLink
            to="/todas"
            className="text-white rounded py-2 w-100 d-inline-block px-1"
          >
            <BsClipboard2CheckFill className="me-1"/>  
            Registradas
          </NavLink>
        </li>
          <NavLink
            to="/entrantes"
            className="text-white rounded py-2 w-100 d-inline-block px-1"
          >
            <BsFileEarmarkTextFill className="me-1" />
            Seguimiento
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/curso"
            className="text-white rounded py-2 w-100 d-inline-block px-1"
          >
            <BsFileEarmarkBreakFill className="me-1" />
            En proceso
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/completas"
            className="text-white rounded py-2 w-100 d-inline-block px-1"
          >
            <BsFillFileEarmarkCheckFill className="me-1" />
            Completas
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/suspension"
            className="text-white rounded py-2 w-100 d-inline-block px-1"
          >
            <BsFillFileEarmarkExcelFill className="me-1" />
            En suspensión
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/expediente"
            className="text-white rounded py-2 w-100 d-inline-block px-1"
          >
            <BsFillFileEarmarkExcelFill className="me-1" />
            Expediente
          </NavLink>
        </li>
        <li>
          <strong className="gobtext">Portal:</strong>
        </li>
        <li>
          <NavLink
            to="/"
            target="_blank"
            className="text-white rounded py-2 w-100 d-inline-block px-1"
          >
            <BsGlobe className="me-1" />
            Sitio WEB
          </NavLink>
        </li>     

        <li>
          <NavLink
            to="/login"
            className="text-white rounded py-2 w-100 d-inline-block px-1"
            onClick={handleLogout}
          >
            <AiOutlineLogout className="me-1" />
            Cerrar sesión
          </NavLink>
        </li>
      </ul>
    </div>
  );
}
